module.exports = __webpack_public_path__ + "static/media/nz.229d2fad.svg";